import fetch from 'isomorphic-fetch'

import {
  COACH_SIGNUP_REQUEST,
  COACH_SIGNUP_SUCCESS,
  COACH_SIGNUP_FAILURE
} from '../actions'

import { userAssignmentPayload, getAPIendpointPrefix } from './apiHelper.js'

export default (phone) => {
  return (dispatch, getState) => {
    const activity = getState().core.activity
    let payload
    try {
      payload = userAssignmentPayload(activity)
    } catch (e) {
      return Promise.reject('cannot post coach signup--missing required data')
    }
    payload.action = phone ? 'accept' : 'decline'
    payload.contact = phone
    const payloadString = JSON.stringify(payload)

    dispatch({ type: COACH_SIGNUP_REQUEST })

    return fetch(getAPIendpointPrefix() + 'api/v1/coach.php',
      {
        method: 'POST',
        mode: 'no-cors',
        headers: { 'Content-Type': 'application/json; charset=utf-8' },
        body: payloadString
      })
      .then(response => {
        const contentType = response.headers.get('content-type')
        if (contentType && contentType.includes('application/json')) {
          return response.json()
        } else {
          return Promise.resolve({ error: 'unknown error' })
        }
      })
      .then(json => {
        return json.error
          ? dispatch({ type: COACH_SIGNUP_FAILURE, payload: json })
          : dispatch({ type: COACH_SIGNUP_SUCCESS, payload: json, acceptedOffer: payload.action === 'accept' })
      })
  }
}
